// TICKET-CSATOLMÁNY FELTÖLTÉS — a ticket-specifikus KÉT végpont-hívás; a szabályok és a folyamat a KÖZÖS
// `lib/attachment-rules.ts`-ben élnek (ott a miért is). Két hely tölt fel ticket-csatolmányt: a
// ticket-részletező panelje ÉS a nyitó-form.
//
// A TOAST-ok SZÁNDÉKOSAN nem itt vannak: a hívó dönti el, mit mond a felhasználónak.
import { api } from '@/lib/api';
import { runPresignedUpload, type AttachmentUploadOutcome } from '@/lib/attachment-rules';

// Újra-exportok: a ticket-oldali hívók egy importból kapják a szabályokat is (a közös modul a forrás).
export {
  ALLOWED_EXTENSIONS,
  ATTACHMENT_ACCEPT,
  MAX_ATTACHMENT_BYTES,
  MAX_ATTACHMENTS,
  extensionOf,
  validateAttachments,
  type AttachmentUploadOutcome,
  type AttachmentValidation,
} from '@/lib/attachment-rules';

/** Egyetlen fájl feltöltése a háromlépéses presigned-folyamattal. SOHA nem dob. */
export async function uploadTicketAttachment(
  ticketId: string,
  file: File,
): Promise<AttachmentUploadOutcome> {
  return runPresignedUpload(file, {
    requestUrl: (body) =>
      api.ticketAttachments.uploadUrl.mutation({ params: { id: ticketId }, body }),
    commit: (body) => api.ticketAttachments.commit.mutation({ params: { id: ticketId }, body }),
  });
}
